import axios from "axios";

const baseURL = process.env.VUE_APP_API;
const baseApi = axios.create({
  baseURL,
  headers: {
    "Access-Control-Allow-Origin": "*"
  }
});

// Interceptor request: setear Authorization SIEMPRE antes de cada request
// Esto evita depender del orden de guards y garantiza que /me nunca se llame sin token
baseApi.interceptors.request.use(
  (config) => {
    const raw = localStorage.getItem("access_token");
    const token = (raw || "").trim();

    // Axios puede tener headers undefined dependiendo de versión/config
    config.headers = config.headers || {};

    // Si token válido -> setear Bearer <token>
    if (token && token !== "null" && token !== "undefined") {
      // Axios puede tener headers undefined dependiendo de versión/config
      (config.headers as any).Authorization = `Bearer ${token}`;
      return config;
    }

    // Si NO hay token -> NO dejar "Bearer" pelado (borrar Authorization si existía, en cualquier casing)
    if ((config.headers as any).Authorization) delete (config.headers as any).Authorization;
    if ((config.headers as any).authorization) delete (config.headers as any).authorization;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default baseApi;
